<template>
  <v-form
      @submit.prevent="login()"
      ref="formRef"
  >
    <v-card-text>
      <!-- backend#57: Konto noch nicht bestaetigt - Hinweis und "erneut senden" -->
      <email-unbestaetigt v-if="emailUnbestaetigt" :email="emailUnbestaetigt"/>
      <v-text-field
          prepend-icon="mdi-email"
          :label="$t('loginForm.email')"
          v-model="form.email"
          :rules="rules.emailRules"
          data-cy="email"
          type="email"
          autocomplete="email"
          persistent-placeholder
      />
      <v-text-field
          prepend-icon="mdi-lock"
          v-bind:label="$t('loginForm.password')"
          v-model="form.password"
          :type="form.showPassword ? 'text' : 'password'"
          :rules="rules.passRules"
          data-cy="password"
          autocomplete="current-password"
          persistent-placeholder
      >
          <template v-slot:append>
            <passwort-auge :sichtbar="form.showPassword" @umschalten="form.showPassword = !form.showPassword" />
          </template>
      </v-text-field>
    </v-card-text>
    <v-card-text>
      <v-row>
        <v-col>
          <v-btn
              type="submit"
              block
              :disabled="
                    (form.password.length < 6 ||
                    form.email.length === 0)
                  "
              color="primary"
              large
              :loading="loginStatusPending || form.loading"
              @click="login()"
              data-cy="login-btn"
          >{{ $t("loginForm.login") }}</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn
              class="mt-4"
              text
              color="primary"
              data-cy="register-button"
              block
              :small="$vuetify.breakpoint.smAndDown"
              @click="
                    routerPush({
                      name: 'Login',
                      params: { mode: 'register', redirect: 1 },
                    })
                  "
          >{{ $t("registerForm.loginPage") }}</v-btn>
        </v-col>
      </v-row>
      <or-component class="px-1"/>

      <v-row class="mb-2">
        <v-col>
          <v-btn
              block
              text
              color="primary"
              data-cy="login-reset-btn"
              @click="$refs.reset.open(form.email)"
          >{{ $t("loginForm.resetPassword") }}</v-btn>
        </v-col>
      </v-row>
    </v-card-text>

    <reset-password-modal ref="reset" :email-rules="rules.emailRules"/>
  </v-form>
</template>

<script>
import PasswortAuge from "../PasswortAuge.vue";
import {mapGetters} from "vuex";
import ResetPasswordModal from "../modal/ResetPasswordModal";
import OrComponent from "../OrComponent";
import EmailUnbestaetigt from "./EmailUnbestaetigt.vue";
import emailRegex from "../../util/emailRegex";
import sicheresZiel from "../../util/umleitungsziel";
import { weiterleiten } from "../../util/weiterleitung";

let vm
export default {
  name: "LoginForm",
  components: { PasswortAuge, OrComponent, ResetPasswordModal, EmailUnbestaetigt},
  computed: {
    ...mapGetters(["snackbar", "baseRedirectServer", "loginStatusPending", "emailUnbestaetigt"]),
  },
  data: () => ({
    rules: {
      emailRules: [
        (v) => !!v || vm.$t("generalForms.email.required"),
        (v) => emailRegex.test(v) || vm.$t("generalForms.email.invalid"),
      ],
      passRules: [
        (v) => !!v || vm.$t("generalForms.pass.required"),
        /*
         * HIER BLEIBT ES BEI SECHS, und zwar ausdruecklich.
         *
         * F-47 (login#4) hebt die Mindestlaenge fuer NEUE Passwoerter auf
         * zwoelf. Die Anmeldemaske darf das nicht uebernehmen: Wer heute ein
         * Passwort mit acht Zeichen hat, muss sich weiterhin anmelden koennen.
         * Eine Laengenpruefung hier wuerde bestehende Konten aussperren, ohne
         * die Sicherheit eines einzigen zu verbessern - das Passwort steht ja
         * schon fest.
         *
         * Genau genommen gehoert an dieser Stelle ueberhaupt keine
         * Laengenpruefung hin; sie ist nur eine Bequemlichkeit gegen Vertipper.
         */
        (v) => v.length >= 6 || vm.$t("generalForms.pass.length"),
      ],
    },
    form: {
      showPassword: false,
      email: "",
      password: "",
      loading: false,
    }
  }),
  created() {
    vm = this
  },
  methods: {
    async createRedirectLink() {
      /*
       * Das Ziel kam hier ungeprueft aus der Route:
       *
       *   href = new URL(decodeURIComponent(this.$route.params.redirect));
       *
       * und der Anmeldetoken wurde daran angehaengt. Wer jemanden dazu bringt,
       * /login/<kodierte-fremde-adresse> zu oeffnen, bekam nach dessen
       * Anmeldung den Token an den eigenen Server geschickt - im Klartext, in
       * der Adresszeile. Ein Link genuegte, und fuer den Angemeldeten sah die
       * Anmeldung ganz normal aus.
       *
       * sicheresZiel laesst nur eigene Adressen durch und faellt sonst auf die
       * Standardadresse zurueck. Siehe login#3.
       *
       * Seit login#2 steht statt des Tokens nur noch ein Einmal-Code in der
       * Adresse - siehe util/weiterleitung.js.
       */
      const ziel = sicheresZiel(
        this.$route.params.redirect,
        this.baseRedirectServer
      );

      //nur das geprueft Ziel weitergeben, nicht den Rohwert aus der Route
      return weiterleiten(this.$store, ziel, this.$route.params.mode, ziel);
    },
    login() {
      let vm = this;
      this.loading = true;
      if (this.$refs.formRef.validate()) {
        this.$store
            .dispatch("login", {
              email: this.form.email.trim().toLowerCase(),
              password: this.form.password.trim(),
            })
            .then(async (r) => {
              //create redirect link when login success otherwise redirect to log-in
              r
                  ? await vm.createRedirectLink()
                  : vm.routerPush({
                    name: "Login",
                    params: {mode: "login", redirect: 1},
                  });
              vm.loading = false;
            });
      }
    },
    routerPush({name, params}) {
      this.$refs.formRef.resetValidation();

      if (this.$route.params.mode === params.mode) return;

      this.$router.push({
        name,
        params,
      });
    },
  }
}
</script>

<style scoped>

</style>
